import moment from "moment";
// import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import GeoJSON from 'ol/format/GeoJSON';
import Feature from 'ol/Feature';
import {Tile as TileLayer, VectorTile as VectorTileLayer} from 'ol/layer';
import XYZ from 'ol/source/XYZ';
import {Vector as VectorLayer, Group as LayerGroup} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import {LineString, Point, Polygon} from 'ol/geom';
import {Circle, Fill, Text, Stroke, Style, Icon} from 'ol/style';
import { Draw, Modify, Snap } from "ol/interaction";
import WKT from "ol/format/WKT";
import {get as getProjection, getTransform} from 'ol/proj';
import Projection from 'ol/proj/Projection';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import {fromLonLat, toLonLat, transform} from 'ol/proj';
import Overlay from 'ol/Overlay';
import TileWMS from 'ol/source/TileWMS';
import TileGrid from 'ol/tilegrid/TileGrid';
import WMTS, { optionsFromCapabilities } from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { getWidth, getTopLeft, buffer } from "ol/extent";

export default {
  data: function() {
    return {
      map: {},
      mapCreated: false,
      overlay: null,
      container: null,
      content: null,
      closer: null,
      filterTreesSource: new VectorSource(),
      filterTreesLayer: null,
      selectionSource: new VectorSource(),
      selectionLayer: null,
      treeSource: new VectorSource(),
      treeLayer: null,
      selectedFeatures: [],
      polyGeom: null,
      today: moment().format("dddd Do MMM YYYY"),
      currYear: parseInt(moment().format("YYYY")),
      saving: false,
      polygonSource: null,
      polygonVector: null,
      modify: null,
      snap: null,
      draw: null,
      polygonAdded: false,
      polygonWkt: null,
      aerialGroup: null,
      aerial: new TileLayer(),
      imageService: new TileLayer({
          visible: false
      }),
      imageService2: new TileLayer({
          visible: false
      }),
      satellite: new TileLayer({
          source: new XYZ({
              url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
          }),
          visible: false,
      }),
      osm: new TileLayer({
          source: new XYZ({
              //url: 'https://{a-c}.forestree.app/mapping/basemap?z={z}&x={x}&y={y}',
              url: 'https://2.base.maps.api.here.com/maptile/2.1/maptile/newest/normal.day.grey/{z}/{x}/{y}/256/png8?app_id=Z0QSJJgX0Wp4n9TiLJqs&app_code=Tmhqj1tSwQMD5nrxbEnHDQ',
          }),
          visible: true,
          crossOrigin: 'anonymous'
      }),
      labels: new TileLayer({
          source: new XYZ({
              url: "https://{1-4}.aerial.maps.ls.hereapi.com/maptile/2.1/labeltile/newest/hybrid.day/{z}/{x}/{y}/256/png8?apiKey=BsTZLKmHt1JtQzlBFwx_uTo5WQIt_wpxsuIky1tEVr4"
          }),
          visible: false,
          maxZoom: 20,
          crossOrigin: "anonymous"
      })
    };
  },
	methods: {
    createMap(defaults, hasPopup = false) {
        var homeLng = parseFloat(defaults.lng);
        var homeLat = parseFloat(defaults.lat);
        var homeZoom = parseFloat(defaults.zoom);

        this.map = new Map({
            target: 'map',
            layers: [
                this.osm,
                this.satellite
            ],
            view: new View({
              projection: 'EPSG:3857',
              center: fromLonLat([homeLng,homeLat], 'EPSG:3857'),
              zoom: homeZoom
            })
        });
        
        if(hasPopup) {
          this.container = document.getElementById('popup');
          this.content = document.getElementById('popup-content');
          this.closer = document.getElementById('popup-closer');
  
          this.overlay = new Overlay({
            element: this.container,
            autoPan: true,
            autoPanAnimation: {
              duration: 250
            }
          });

          this.map.addOverlay(this.overlay);
  
          this.closer.onclick = () => {
            this.overlay.setPosition(undefined);
            this.closer.blur();
            return false;
          };
        } else {
          this.overlay = null;
        }

        this.mapCreated = true;
        
        this.polygonSource = new VectorSource();

        this.polygonVector = new VectorLayer({
          source: this.polygonSource,
          style: new Style({
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.1)"
            }),
            stroke: new Stroke({
              color: "#dd6b20",
              width: 3
            }),
            image: new Circle({
              radius: 7,
              fill: new Fill({
                color: "#dd6b20"
              })
            })
          })
        });
        this.map.addLayer(this.polygonVector);
        
        this.selectionSource = new VectorSource();

        this.selectionLayer = new VectorLayer({
          source: this.selectionSource,
          style: new Style({
            image: new Circle({
              radius: 9,
              fill: new Fill({
                color: "rgba(254, 240, 138, 0.2)"
              }),
              stroke: new Stroke({
                color: "rgba(254, 240, 138, 1)",
                width: 4
              })
            })
          })
        });
        this.map.addLayer(this.selectionLayer);

        this.selectionLayer.setZIndex(20);

        this.modify = new Modify({ source: this.polygonSource });

        this.draw = new Draw({
          source: this.polygonSource,
          type: "Polygon"
        });

        this.snap = new Snap({ source: this.polygonSource });

        //this.enablePolygonDraw();

        var predefinedStyles = {
          'circles-zoom': {
            symbol: {
              symbolType: 'circle',
              size: [
                'interpolate',
                ['exponential', 2.5],
                ['zoom'],
                2, 8, 20, 32
              ],
              //color: '#4CAF50',
              color: [
                'interpolate',
                ['linear'],
                ['get', 'priority'],
                1, '#16a34a',
                2, '#ca8a04',
                3, '#ef4444',
                4, '#b91c1c'
              ],
              offset: [0, 0],
              opacity: 0.7
            }
          }
        };

        this.filterTreesSource = new VectorSource();
  
        this.filterTreesLayer = new WebGLPointsLayer({
          source: this.filterTreesSource,
          style: predefinedStyles['circles-zoom'],
          disableHitDetection: false
        });


        this.map.addLayer(this.filterTreesLayer);

        
        this.addImagery();
    },
    enablePolygonDraw() {
      this.polygonSource.clear();
      this.map.addInteraction(this.modify);
      this.map.addInteraction(this.draw);
      this.map.addInteraction(this.snap);
      var format = new WKT();
      
      this.draw.on("drawend", e => {
        this.map.removeInteraction(this.draw);
        this.polygonAdded = true;
        var geom = e.feature.getGeometry();
        this.polygonWkt = format.writeGeometry(geom);
        this.polyGeom = e.feature.getGeometry();
        this.selectFeatures();
      });

      this.modify.on("modifyend", e => {
        this.polygonWkt = format.writeGeometry(
            e.features.getArray()[0].getGeometry()
        );
        this.polyGeom = e.features.getArray()[0].getGeometry();
        this.selectFeatures();
      });
    },
    selectFeatures() {
      this.selectedFeatures = [];
      this.selectionSource.clear();
      var features = this.filterTreesLayer.getSource().getFeatures();
      for (var i = 0 ; i < features.length; i++){
        if(this.polyGeom.intersectsExtent(features[i].getGeometry().getExtent())){
          this.selectedFeatures.push(
            {mid: features[i].get('id'), tree_id: features[i].get('tree_id')}
          );
          this.selectionSource.addFeature(features[i]);
        }
      }
      //this.selectionSource.addFeatures(this.selectedFeatures);
      this.map.render();
    },
    restart() {
      this.map.addInteraction(this.draw);
      this.polygonSource.clear();
      this.polygonAdded = false;
      this.fetching = false;
      this.polygonWkt = null;
      this.selectedFeatures = [];
      this.selectionSource.clear();
      this.polyGeom = null;
    },
    addTreesGL(trees){

      if(trees && trees.length > 0) {
        this.filterTreesSource.clear();

        var count = 0
        var features=[];
        trees.forEach(t => {
            if(t.tree){
              var thisFeature = t;
              var treeId = t.tree.id;
              var lat = t.tree.lat;
              var lng = t.tree.lng;
            } else {
              var thisFeature = t;
              var treeId = t.id;
              var lat = t.lat;
              var lng = t.lng;
            }
            var thisFeature = t;
            if(thisFeature && thisFeature.id) {
              features.push(
                new Feature({
                  id: thisFeature.id,
                  tree_id: treeId,
                  priority: thisFeature.inspection ? thisFeature.inspection.priority : 1,
                  geometry: new Point(fromLonLat([parseFloat(lng), parseFloat(lat)], 'EPSG:3857'))
                })
            );
            }
            count++;

            if(count === trees.length) {
              this.filterTreesSource.addFeatures(features);
              this.map.render();
            }
          
        });
          
      } else {
        this.filterTreesSource.clear();
      }

      if(this.polyGeom) {
        this.selectFeatures();
      } else {
        this.selectedFeatures = [];
        this.polyGeom = null;
      }


    },
    baseMapSwitch() {
        if (this.osm.getVisible()) {
            if (this.defaults.imagery) {
                this.imageService.setVisible(true);
                this.imageService2.setVisible(true);
                this.labels.setVisible(true);
            } else if (this.defaults.homeCenter.tile) {
                this.aerial.setVisible(true);
                this.labels.setVisible(true);
            } else {
                this.satellite.setVisible(true);
                this.labels.setVisible(true);
            }
            this.osm.setVisible(false);
        } else {
            if (this.defaults.imagery) {
                this.imageService.setVisible(false);
                this.imageService2.setVisible(false);
                this.labels.setVisible(false);
            } else if (this.defaults.homeCenter.tile) {
                this.aerial.setVisible(false);
                this.labels.setVisible(false);
            } else {
                this.satellite.setVisible(false);
                this.labels.setVisible(false);
            }
            this.osm.setVisible(true);
        }
    },
    addImagery() {

        if (this.defaults.imagery) {

          
            var showAerial = localStorage.getItem('aerial');
              
            if(showAerial === "true") {
                this.osm.setVisible(false);
            }

            var imageUrl = '';
            var source = null;
            var source2 = null;
            var visState = false;

            if (this.defaults.imagery.provider === 'metromap') {
                imageUrl = `https://pathapi.metromap.com.au/api-link/${this.defaults.imagery.key}/wmts/Australian_capital_cities_latest/default/GoogleMapsCompatibleExt:epsg:3857/{z}/{y}/{x}.jpgpng`;
                source = new XYZ({
                    urls: [imageUrl],
                    tilePixelRatio: 1
                });
            }
        
            if(this.defaults.imagery.provider === 'metromap-xyz') {
                imageUrl = `https://api-v3.metromap.com.au/tiles/xyz/Australian_capital_cities_latest/{z}/{y}/{x}.jpgpng?key=${this.defaults.imagery.key}`;
                source = new XYZ({
                    urls: [imageUrl],
                    tilePixelRatio: 1
                });
            }
            

            if(this.defaults.imagery.provider === 'metromap-wmts') {
                const projection = getProjection('EPSG:3857');
                const projectionExtent = projection.getExtent();
                const size = getWidth(projectionExtent) / 256;
                const resolutions = new Array(22);
                const matrixIds = new Array(22);
                for (let z = 0; z < 22; ++z) {
                  resolutions[z] = size / Math.pow(2, z);
                  matrixIds[z] = z;
                }

                source = new WMTS({
                    url: `https://api.metromap.com.au/ogc/key/${this.defaults.imagery.key}/service?SERVICE=WMTS`,
                    layer: 'Australian_capital_cities_latest',
                    matrixSet: 'webmercator',
                    format: 'image/png',
                    projection: projection,
                    tileGrid: new WMTSTileGrid({
                      origin: getTopLeft(projectionExtent),
                      resolutions: resolutions,
                      matrixIds: matrixIds,
                    }),
                    style: 'default',
                    wrapX: true,
                  });
            }

            if (this.defaults.imagery.provider === 'nearmap') {
                imageUrl = `https://au0.nearmap.com/maps/z={z}&x={x}&y={y}&version=2&nml=Vert&client=wmts_integration&httpauth=false&apikey=${this.defaults.imagery.key}`;
                source = new XYZ({
                    urls: [imageUrl],
                    tilePixelRatio: 1
                });
            }

            if (this.defaults.imagery.provider === 'esri' && this.defaults.imagery.url) {
                imageUrl = `${this.defaults.imagery.url}/tile/{z}/{y}/{x}`;
                source = new XYZ({
                    urls: [imageUrl],
                    tileSize: 512,
                    maxZoom: 19,
                });
            }

            if(this.defaults.imagery.provider === 'victoria') {
                const projExtent = getProjection('EPSG:3857').getExtent();
                const startResolution = getWidth(projExtent) / 512;
                const resolutions = new Array(22);
                for (let i = 0, ii = resolutions.length; i < ii; ++i) {
                  resolutions[i] = startResolution / Math.pow(2, i);
                }
                const tileGrid = new TileGrid({
                  extent: projExtent,
                  resolutions: resolutions,
                  tileSize: [512, 512],
                });

                source =new TileWMS({
                    url: 'https://base.maps.vic.gov.au/service?',
                    params: {'LAYERS': 'AERIAL_WM', 'TILED': true},
                    transition: 0,
                    tileGrid: tileGrid,
                  });
            }
            
            if(this.defaults.imagery.provider === 'dual-wms') {
                const projExtent = getProjection('EPSG:3857').getExtent();
                const startResolution = getWidth(projExtent) / 512;
                const resolutions = new Array(22);
                for (let i = 0, ii = resolutions.length; i < ii; ++i) {
                resolutions[i] = startResolution / Math.pow(2, i);
                }
                const tileGrid = new TileGrid({
                extent: projExtent,
                resolutions: resolutions,
                tileSize: [512, 512],
                });

                source =new TileWMS({
                    url: this.defaults.imagery.url,
                    transition: 0,
                    tileGrid: tileGrid,
                    format: 'image/png',
                });
                
                source2 =new TileWMS({
                    url: this.defaults.imagery.url2,
                    transition: 0,
                    tileGrid: tileGrid,
                });
            }

            this.imageService = new TileLayer({
                source: source,
                visible: visState
            });

            this.imageService2 = new TileLayer({
                source: source2,
                visible: visState,
                crossOrigin: 'anonymous'
            });
            
            this.aerialGroup = new LayerGroup({
                layers: [
                    this.imageService2,
                    this.imageService,
                    this.labels
                ]
            });

            this.labels.setVisible(visState);

            var layers = this.map.getLayers();
            layers.insertAt(0, this.aerialGroup);
        } else if (this.defaults.homeCenter.tile) {

            var visState = false;

            if(this.imageService.getVisible() || this.imageService2.getVisible() || showAerial === "true") {
                visState = true;
            }

            this.aerial = new TileLayer({
                source: new XYZ({
                    urls:[
                        `https://tile.forestree.dev/tile/${this.defaults.homeCenter.tile}/{z}/{x}/{y}.jpg`
                    ],
                    minZoom: 12,
                    maxZoom: 20,
                    tilePixelRatio: 1
                }),
                visible: visState,
            });

            this.aerialGroup = new LayerGroup({
                layers: [
                    this.aerial,
                    this.labels
                ]
            });
            
            this.labels.setVisible(visState);

            var layers = this.map.getLayers();
            layers.insertAt(0, this.aerialGroup);

        } else {}
    },
}}